// Fuso do browser (IANA). Usado no drip_config para avaliar a janela de envio
// no fuso em que o operador configurou 10-21, em vez do default UTC da inbox.
export const browserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
